import {Box, Card, Grid, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {InfoElements} from "../../constants/InfoCardElements";
import get from "lodash.get";
import moment from "moment";
import {isAbhiInsurer, isVitrayaInternalUser} from "../../constants/UserAuth";

function InfoCard(props) {
    const {claimData} = props;
    // claimData.policyNumber = "GHI-123r2l32"
    const [infoItems, setInfoItems] = useState([]);
    let filteredInfoElements = [];

    const columnsToExclude = [
        "Last Re-Run",
        "Module Status",
        "Bill Parsed Accuracy",
        "Out Of Scope Hospital",
        "Claim Type",
        "Claim Status while Digitisation",
        "Digitization Data Recieved Time"
    ];
    const abhiUserColumnsToExclude = [
        "Enhancement Status",
        "Last Re-Run",
        "Module Status",
        "Bill Parsed Accuracy",
        "Out Of Scope Hospital",
        "Claim Type",
    ];
    const abhiReplacementTitles = {
        'Created on': 'Claim Details sent to Vitraya'
    }
    useEffect(() => {
        let baseItems = [];
        if (isVitrayaInternalUser()) {
            baseItems = InfoElements;
        }
        if (
            !isVitrayaInternalUser() && isAbhiInsurer()
        ) {
            filteredInfoElements = InfoElements.filter(
                (column) => !columnsToExclude.includes(column.title)
            );
            baseItems = filteredInfoElements;
        }
        //Remove Status if user is not Admin ABHI user
        if (
            !isVitrayaInternalUser() && isAbhiInsurer()
        ) {
            filteredInfoElements = InfoElements.filter(
                (column) => !abhiUserColumnsToExclude.includes(column.title)
            );
            filteredInfoElements.map((item, index) => {
                if (get(abhiReplacementTitles, [item.title], 'Something Random') !== 'Something Random') {
                    item.title = get(abhiReplacementTitles, [item.title], 'Something Random')
                }
            })
            baseItems = filteredInfoElements;
        }

        // Filter out conditional items that don't meet criteria
        const finalItems = baseItems.filter((item) => {
            if (item.type === "coiNumber" ) {
                return ((claimData?.policyNumber?.includes("GHI") || claimData?.policyNumber?.includes("ghi")) && !claimData?.productName?.includes("Employer-Employee"));
            }
            if (item.type === "stpStatus") {
                return claimData?.stpStatus;
            }
            if (item.type === "product") {
                return (claimData?.policyNumber?.includes("GHI") || claimData?.policyNumber?.includes("ghi"));
            }
            if (item.type === "mphNumber") {
                return claimData?.productName?.includes("Employer-Employee");
            }
            return true; // Keep all other items
        });

        setInfoItems(finalItems);
    }, [InfoElements, claimData]);





    return (
        <Card
            style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "1rem",
                marginLeft: "10px",
                marginRight: "5px",
                marginTop: "15px",
                padding: "0.5rem",
            }}
        >
            {infoItems.map((item, index) => (
                <Grid textAlign={"center"} style={{gap: "10px"}} key={index}>
                                {item.type === "string" && (
                                    <Grid
                                        className="flex-box"
                                        style={{
                                            padding: "2px 5px",
                                            minheight: "3rem",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            component={"p"}
                                            sx={{fontSize: "15px", color: "#B1B3B3"}}
                                        >
                                            {item.title}
                                        </Typography>
                                        <Typography variant="subTitle1" component={"p"}>
                                            {claimData[item.field] === null ? (
                                                "Not Found"
                                            ) : item.field !== "hospitalName" ? (
                                                get(claimData, [item.field], "Not Found")
                                            ) : (
                                                // : `${claimData[item.field]} ,
                                                // ${claimData["hospitalCode"]}`
                                                <span>
                          {" "}
                                                    {claimData[item.field]}
                                                    <br/>
                                                    {claimData["hospitalCode"]}
                        </span>
                                            )}
                                        </Typography>
                                    </Grid>
                                )}
                                {item.type === "string_with_underscores" && (
                                    <Grid
                                        className="flex-box"
                                        style={{
                                            padding: "2px 5px",
                                            minheight: "3rem",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            component={"p"}
                                            sx={{fontSize: "15px", color: "#B1B3B3"}}
                                        >
                                            {item.title}
                                        </Typography>
                                        <Typography variant="subTitle1" component={"p"}>
                                            {claimData[item.field] === null ? (
                                                "Not Found"
                                            ) : (
                                                get(claimData, [item.field], "Not Found").replaceAll('_', ' ')
                                            )}
                                        </Typography>
                                    </Grid>
                                )}
                                {item.type === "date" && (
                                    <Grid
                                        className="flex-box"
                                        style={{
                                            padding: "2px 5px",
                                            minHeight: "3rem",

                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            component={"p"}
                                            sx={{fontSize: "15px", color: "#B1B3B3"}}
                                        >
                                            {item.title}
                                        </Typography>
                                        <Typography variant="subTitle1" component={"p"}>
                                            {get(claimData, [item.field], null) !== null && moment(claimData[item.field]).format("DD-MM-YYYY")}
                                            {get(claimData, [item.field], null) === null && 'Claim Processing'}
                                            <br/>
                                            {get(claimData, [item.field], null) !== null && moment(claimData[item.field]).format("h:mm a")}
                                        </Typography>
                                    </Grid>
                                )}
                                {item.type === "amount" && (
                                    <Grid
                                        className="flex-box"
                                        style={{
                                            padding: "2px 5px",
                                            minHeight: "3rem",

                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            component={"p"}
                                            sx={{fontSize: "15px", color: "#B1B3B3"}}
                                        >
                                            {item.title}
                                        </Typography>
                                        <Typography
                                            variant="subTitle1"
                                            component={"p"}
                                            style={{
                                                color:
                                                    Math.trunc(claimData[item.field]) > 0
                                                        ? "green"
                                                        : "#000",
                                            }}
                                        >
                                            &#x20b9;{" "}
                                            {claimData[item.field] === undefined ||
                                            claimData[item.field] === null
                                                ? "0"
                                                : claimData[item.field].toLocaleString("en-IN")}
                                            {claimData[item.field] !== 0 &&
                                                claimData[item.field] !== null &&
                                                ` (${Math.trunc(
                                                    (claimData[item.field] /
                                                        claimData?.claimBillAmountRequested) *
                                                    100
                                                )}  %)`}
                                        </Typography>
                                    </Grid>
                                )}
                                {item.type === "accuracy" && (
                                    <Grid
                                        className="flex-box"
                                        style={{
                                            padding: "2px 5px",
                                            minHeight: "3rem",

                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            component={"p"}
                                            sx={{fontSize: "15px", color: "#B1B3B3"}}
                                        >
                                            {item.title}
                                        </Typography>
                                        <Typography
                                            variant="subTitle1"
                                            component={"p"}
                                            style={{fontSize: 15}}
                                        >
                                            {claimData?.tariffMatchPercentage <= 100 &&
                                            claimData?.tariffMatchPercentage > 89 ? (
                                                <span style={{color: "green", fontWeight: 700}}>
                          {claimData?.tariffMatchPercentage} &#x25;
                        </span>
                                            ) : claimData?.tariffMatchPercentage <= 89 &&
                                            claimData?.tariffMatchPercentage > 79 ? (
                                                <span style={{color: "orange", fontWeight: 700}}>
                          {claimData?.tariffMatchPercentage} &#x25;
                        </span>
                                            ) : (
                                                <span style={{color: "red", fontWeight: 700}}>
                          {claimData?.tariffMatchPercentage || 0} &#x25;
                        </span>
                                            )}
                                        </Typography>
                                    </Grid>
                                )}
                                {item.type === "scope" && (
                                    <Grid
                                        className="flex-box"
                                        style={{
                                            padding: "2px 5px",
                                            height: "3rem",

                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            component={"p"}
                                            sx={{fontSize: "15px", color: "#B1B3B3"}}
                                        >
                                            {item.title}
                                        </Typography>
                                        <Typography
                                            variant="subTitle1"
                                            component={"p"}
                                            style={{fontSize: 15}}
                                        >
                                            {claimData?.outOfScopeHospital === true ? (
                                                <span style={{fontSize: "15px", color: "red"}}>
                          True
                        </span>
                                            ) : (
                                                <span style={{fontSize: "15px"}}>False</span>
                                            )}
                                        </Typography>
                                    </Grid>
                                )}
                                {item.type === "enhancement" && (
                                    <Grid
                                        className="flex-box"
                                        style={{
                                            padding: "2px 5px",
                                            height: "3rem",

                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            component={"p"}
                                            sx={{fontSize: "15px", color: "#B1B3B3"}}
                                        >
                                            {item.title}
                                        </Typography>
                                        {claimData?.enhancementStatus &&
                                        claimData?.combinedStatus !== null ? (
                                            <span>
                        {" "}
                                                {claimData?.enhancementStatus?.includes("SUCCESSFUL") ||
                                                claimData?.enhancementStatus?.includes(
                                                    "IN_PROGRESS"
                                                ) ? (
                                                    <span style={{color: "green"}}>
                            {claimData?.enhancementStatus.replaceAll("_", " ")}
                          </span>
                                                ) : claimData?.enhancementStatus.includes("FAILED") ||
                                                claimData?.enhancementStatus?.includes(
                                                    "NOT_FOUND"
                                                ) ? (
                                                    <span style={{color: "red"}}>
                            {claimData?.enhancementStatus.replaceAll("_", " ")}
                          </span>
                                                ) : claimData?.enhancementStatus.includes(
                                                    "OUT_OF_SCOPE"
                                                ) ? (
                                                    <span style={{color: "red"}}>
                            {" "}
                                                        {claimData?.enhancementStatus.replaceAll("_", " ")}
                          </span>
                                                ) : (
                                                    claimData?.enhancementStatus.replaceAll("_", " ")
                                                )}{" "}
                      </span>
                                        ) : (
                                            "-"
                                        )}
                                    </Grid>
                                )}
                                {item.type === "moduleStatus" && (
                                    <Grid
                                        className="flex-box"
                                        style={{
                                            padding: "2px 5px",
                                            minHeight: "3rem",

                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            component={"p"}
                                            sx={{fontSize: "15px", color: "#B1B3B3"}}
                                        >
                                            {item.title}
                                        </Typography>
                                        {claimData.adjudicationStatus.toLowerCase() === "pending" ? (
                                            <Typography
                                                variant="body1"
                                                component={"p"}
                                                style={{ color: "orange", fontSize: 15, textAlign: "center" }}
                                            >{ claimData?.enhancementStatus?.includes("IN_PROGRESS") ?
                                                (
                                                    <Typography
                                                        variant="body1"
                                                        component={"p"}
                                                        style={{
                                                            fontSize: 15,
                                                        }}
                                                    >
                                                        ENHANCEMENT IN PROGRESS
                                                    </Typography>
                                                ) : (
                                                    <Typography
                                                        variant="body1"
                                                        component={"p"}
                                                        style={{
                                                            fontSize: 15,
                                                        }}
                                                    >
                                                        ENHANCEMENT AWAITED
                                                    </Typography>
                                                )
                                            }
                                            </Typography>
                                        ) : (
                                        <span
                                            style={{
                                                // display: "flex",
                                                gap: "20px",
                                                // justifyContent: "center",
                                                // alignItems: "center",
                                                lineBreak: "strict",
                                                maxWidth: "fit-content",
                                            }}
                                        >
                      {" "}
                                            {claimData?.combinedStatus &&
                                                claimData?.combinedStatus !== null &&
                                                claimData?.combinedStatus.split(",").map((x, index) =>
                                                    x.includes("APPLIED") ||
                                                    x.includes("SUCCESSFUL") ||
                                                    x.includes("ACCEPTED") ? (
                                                        <Typography
                                                            key={index}
                                                            variant="body1"
                                                            component={"p"}
                                                            style={{
                                                                color: "green",
                                                                fontSize: 15,
                                                            }}
                                                        >
                                                            {x.replaceAll("_", " ").toUpperCase()}
                                                        </Typography>
                                                    ) : x.includes("FAILED") ||
                                                    x.includes("INVALID") ||
                                                    x.includes("ERROR") ||
                                                    x.includes("out of scope") ||
                                                    x.includes("REJECT") ||
                                                    x.includes("REJECTED") ? (
                                                        <Typography
                                                            key={index}
                                                            variant="body1"
                                                            component={"p"}
                                                            style={{
                                                                color: "red",
                                                                fontSize: 15,
                                                            }}
                                                        >
                                                            {x.replaceAll("_", " ").toUpperCase()}
                                                        </Typography>
                                                    ) : x.includes("QUERY") || x.includes("PENDING") || x.includes("AWAITED") ? (
                                                        <Typography
                                                            key={index}
                                                            variant="body1"
                                                            component={"p"}
                                                            style={{
                                                                color: "orange",
                                                                fontSize: 15,
                                                            }}
                                                        >
                                                            {x.replaceAll("_", " ").toUpperCase()}
                                                        </Typography>
                                                    ) : (
                                                        <Typography
                                                            key={index}
                                                            variant="body1"
                                                            component={"p"}
                                                            style={{fontSize: 15, textAlign: "center"}}
                                                        >
                                                            {x.replaceAll("_", " ")}
                                                        </Typography>
                                                    )
                                                )}{" "}
                    </span>
                                        )}
                                    </Grid>
                                )}
                                {item.type === "claimStatus" && (
                                    <Grid
                                        className="flex-box"
                                        style={{
                                            padding: "2px 5px",
                                            height: "3rem",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            component={"p"}
                                            sx={{fontSize: "15px", color: "#B1B3B3"}}
                                        >
                                            {item.title}
                                        </Typography>
                                        <span>
                      {claimData?.adjudicationStatus === "APPROVED" || (claimData?.adjudicationStatus || "").includes('Authorized') ? (
                          <Typography
                              variant="subTitle1"
                              component={"p"}
                              style={{color: "green", fontSize: 15}}
                          >
                              {claimData?.adjudicationStatus?.replaceAll("_", " ")}
                          </Typography>
                      ) : claimData?.adjudicationStatus === "PENDING" || (claimData?.adjudicationStatus || "").includes('Query') ? (
                          <Typography
                              variant="subTitle1"
                              component={"p"}
                              style={{color: "orange", fontSize: 15}}
                          >
                              {claimData?.adjudicationStatus?.replaceAll("_", " ")}
                          </Typography>
                      ) : (
                          <Typography
                              variant="subTitle1"
                              component={"p"}
                              style={{color: "red", fontSize: 15}}
                          >
                              {claimData?.adjudicationStatus?.replaceAll("_", " ")}
                          </Typography>
                      )}
                    </span>
                                    </Grid>
                                )}
                                {item.type === "coiNumber" && (
                                    <Grid
                                        className="flex-box"
                                        style={{
                                            padding: "2px 5px",
                                            height: "3rem",

                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            component={"p"}
                                            sx={{fontSize: "15px", color: "#B1B3B3"}}
                                        >
                                            {item.title}
                                        </Typography>
                                        <Typography
                                            variant="subTitle1"
                                            component={"p"}
                                            style={{fontSize: 15}}
                                        >
                                                <span style={{fontSize: "15px"}}>
                                                    {claimData?.policyNumber}
                                                </span>

                                        </Typography>
                                    </Grid>
                                )}
                    {item.type === "mphNumber" && (
                        <Grid
                            className="flex-box"
                            style={{
                                padding: "2px 5px",
                                height: "3rem",

                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Typography
                                variant="body1"
                                component={"p"}
                                sx={{fontSize: "15px", color: "#B1B3B3"}}
                            >
                                {item.title}
                            </Typography>
                            <Typography
                                variant="subTitle1"
                                component={"p"}
                                style={{fontSize: 15}}
                            >
                                                <span style={{fontSize: "15px"}}>
                                                    {claimData?.groupPolicyNumber}
                                                </span>

                            </Typography>
                        </Grid>
                    )}
                                {item.type === "product" && (
                                    <Grid
                                        className="flex-box"
                                        style={{
                                            padding: "2px 5px",
                                            height: "3rem",

                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            component={"p"}
                                            sx={{fontSize: "15px", color: "#B1B3B3"}}
                                        >
                                            {item.title}
                                        </Typography>
                                        <Typography
                                            variant="subTitle1"
                                            component={"p"}
                                            style={{fontSize: 15}}
                                        >
                                                <span style={{fontSize: "15px"}}>
                                                    GAH
                                                </span>

                                        </Typography>
                                    </Grid>
                                )}
                                {item.type === "stpStatus" &&  claimData?.stpStatus.includes("APPROVED") &&(
                                        < Grid
                                            className="flex-box"
                                            style={{
                                                padding: "2px 5px",
                                                height: "3rem",

                                                // justifyContent: "center",
                                                // alignItems: "center",
                                            }}
                                        >
                                            <Typography
                                                variant="body1"
                                                component={"p"}
                                                sx={{fontSize: "15px", color: "#B1B3B3"}}
                                            >
                                                {item.title}
                                            </Typography>
                                            <Typography
                                                variant="subTitle1"
                                                component={"p"}
                                                style={{fontSize: 15}}
                                            >
                                                <span style={{fontSize: "15px"}}>
                                                    {claimData.stpStatus}
                                                </span>

                                            </Typography>
                                        </Grid>
                                )}
                </Grid>
            ))}
        </Card>
    );
}

export default InfoCard;
